// import HeroHome from '../components/HeroHome';
import LandingPage from "../components/LandingPage"
import React from "react"
export default function Index() {
  return (
    <React.Fragment>
      {/* <HeroHome /> */}
      <LandingPage />
    </React.Fragment>
  )
}
